// extracted by mini-css-extract-plugin
export default {"container":"SegmentedGroup_container__YvZLt"};